import 'antd/dist/antd.css';
import './App.scss';
import { useFetchData } from './hooks/useFetchData';
import { Provider } from './context/appContext';
import { ConfigProvider } from "antd"

import esEs from 'antd/lib/locale/es_ES'

// @pages
import Pages from 'pages'

export default function App() {
  const context = useFetchData();

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Arial"
        }
      }}
    >
      <Provider locale={esEs} value={context}>
        <Pages context={context} />
      </Provider>
    </ConfigProvider>
  );
}
